/**
 * Node customizado para fim do fluxo
 * Estilo visual diferenciado com ícone de Flag
 * Inclui toolbar flutuante ao selecionar (apenas copiar ID disponível)
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { Flag } from 'lucide-react';
import { FlowNodeData } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node de fim
 */
export function EndNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  
  return (
    <div className="bg-destructive text-destructive-foreground rounded-lg shadow-lg border-2 border-destructive min-w-[180px]">
      {/* Toolbar flutuante - apenas copiar ID (end não pode ser editado/excluído) */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType="end"
        isVisible={selected}
      />
      
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-destructive !border-destructive-foreground !w-3 !h-3"
      />
      
      <div className="flex items-center gap-2 p-3">
        <div className="bg-destructive-foreground/20 p-2 rounded">
          <Flag className="h-4 w-4" />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-sm">Fim</div>
          <div className="text-xs opacity-90">Finalizar fluxo</div>
        </div>
      </div>
    </div>
  );
}
